import { render, staticRenderFns } from "./RateDossieSelected.vue?vue&type=template&id=4d5640eb&"
import script from "./RateDossieSelected.vue?vue&type=script&lang=js&"
export * from "./RateDossieSelected.vue?vue&type=script&lang=js&"
import style0 from "./RateDossieSelected.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports